import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { useAdminAuth } from './PersonnelAuthProvider'

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const auth = useAdminAuth()
  const location = useLocation()

  if (!auth.bearerToken) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to='/adminLogin' state={{ from: location }} replace />
  }

  return children
}

export default ProtectedRoute
